<div class="parts-information" [class.quote-readonly-mode]="isViewMode">
  <!-- Global Tooltip Container -->
  <div class="global-tooltip" *ngIf="isTooltipVisible" [style.left.px]="tooltipPosition.x"
    [style.top.px]="tooltipPosition.y">
    {{ tooltipText }}
  </div>

  <!-- Loading Overlay for File Upload and Extraction -->
  <div *ngIf="isFileUploading" class="loading-overlay">
    <img src="assets/img/Loader.gif" alt="Loading.." />
  </div>

  <!-- Hidden file input for uploads -->
  <input #fileInput type="file" multiple
    accept=".step,.stp,.sldprt,.igs,.iges,.ipt,.x_t,.stl,.obj,.3mf,.pdf,.dwg,.dxf,.slddrw,.png,.jpg,.bmp,.tif"
    style="display: none;">

  <!-- Initial View - Quote Summary with Add Part Button -->
  <div class="quote-summary-view" *ngIf="!hasParts">
    <div class="quote-summary-header">
      <h2>Quote Summary</h2>
    </div>

    <!-- Quote Information Display -->
    <div class="quote-info-section">
      <div class="quote-info-grid">
        <!-- Company Details Column -->
        <div class="company-details-row">
          <div class="info-field input-width">
            <input class="text-truncate" type="text" [value]="quoteDetails.companyName" placeholder="Enter Company Name"
              readonly>
          </div>
          <div class="info-field input-width-term">
            <label>Quote #</label>
            <input type="text" [value]="quoteDetails.quoteNumber" placeholder="Enter Quote Number" readonly>
          </div>
          <div class="info-field">
            <label>Quote Date</label>
            <input type="text" [value]="quoteDetails.quoteDate | date:'MM/dd/yyyy'" readonly>
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-width">
            <div class="tooltip-container">
              <input class="text-truncate" type="email" [value]="quoteDetails.companyEmail"
                placeholder="enter company email" readonly>
              <div class="tooltip-popup">
                {{quoteDetails.companyEmail}}
              </div>
            </div>
          </div>

          <div class="info-field input-width-term">
            <label>Payment Terms</label>
            <input class="text-truncate" type="text" [value]="quoteDetails.paymentTerm"
              placeholder="Select Payment Term" readonly>
          </div>
          <div class="info-field">
            <label>Valid Until</label>
            <input type="text" [value]="quoteDetails.quoteExpiryDate | date:'MM/dd/yyyy'" placeholder="MM/DD/YYYY"
              readonly>
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-width">
            <input type="tel" [value]="quoteDetails.companyPhone" placeholder="Enter Phone Number" readonly>
          </div>
        </div>
        <div class="company-details-row">
          <div class="info-field input-full-width">
            <input type="text" [value]="quoteDetails.address" placeholder="String value" readonly>
          </div>
        </div>

      </div>
    </div>

    <!-- Instructional Message -->
    <div class="instruction-box">
      <p>Get started with your RFQ by adding a part you'd like to quote. Once added, you'll be able to add prices,
        quantities, and lead times.</p>
    </div>

    <!-- Add Part Button -->
    <div class="add-part-section" *ngIf="integrationType !== 'MFG'">
      <button class="btn btn-primary add-part-btn" (click)="startAddingPart()">
        Add a Part Now
      </button>
    </div>
  </div>

  <!-- File Upload View - Part File Upload -->
  <div class="file-upload-view" *ngIf="hasParts && isFileUploadView">
    <div class="file-upload-header">
      <div class="part-info-fields">
        <div class="part-field editable-textbox input-group enter-rfq-name">
          <input type="text" [ngModel]="currentPart.partName"
            (ngModelChange)="onPartFieldChange(currentPartIndex, 'partName', $event)" placeholder="Add Part Name"
            [readonly]="config.readonly || integrationType === 'MFG'">
        </div>
        <div class="part-field editable-textbox input-group enter-rfq-name">
          <input type="text" [ngModel]="currentPart.partNumber"
            (ngModelChange)="onPartFieldChange(currentPartIndex, 'partNumber', $event)" placeholder="Add Part Number"
            [readonly]="config.readonly || integrationType === 'MFG'">
        </div>
      </div>
    </div>

    <div class="file-upload-content">
      <h2>Start Quoting Your Part By Uploading Files</h2>

      <!-- 3D Model File Upload -->
      <div class="file-upload-section">
        <h3>Upload 3D Model File</h3>
        <p class="file-types">.step, .stp, .sldprt, .igs, .iges, .ipt, .x_t, .stl, .obj, .3mf</p>

        <!-- Show upload area only if no 3D file exists -->
        <div class="upload-area" *ngIf="!has3DFile()" (click)="onFileUploadRequest(currentPartIndex, '3d')"
          (dragover)="onDragOver($event)" (drop)="onDrop($event, '3d')">
          <div class="upload-content">
            <p>Drag and drop a file here or</p>
            <button class="upload-link">Click to upload</button>
          </div>
        </div>

        <!-- Display uploaded 3D files -->
        <div class="uploaded-files" *ngIf="get3DFiles().length > 0">
          <div class="file-item" *ngFor="let file of get3DFiles(); let i = index; trackBy: trackByFileIndex">
            <span class="file-name">{{ file.fileName }}</span>
            <button class="remove-file-btn" (click)="remove3DFile(i)" title="Remove file">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                  fill="#212A37" />
                <path
                  d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                  fill="#212A37" />
                <path
                  d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                  fill="#212A37" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                  fill="#212A37" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- 2D Drawing File Upload -->
      <div class="file-upload-section">
        <h3>Upload 2D Drawing File</h3>
        <p class="file-types">.pdf, .dwg, .dxf, .slddrw, .png, .jpg, .bmp, .tif</p>

        <!-- Show upload area only if no 2D file exists -->
        <div class="upload-area" *ngIf="!has2DFile()" (click)="onFileUploadRequest(currentPartIndex, '2d')"
          (dragover)="onDragOver($event)" (drop)="onDrop($event, '2d')">
          <div class="upload-content">
            <p>Drag and drop a file here or</p>
            <button class="upload-link">Click to upload</button>
          </div>
        </div>

        <!-- Display uploaded 2D files -->
        <div class="uploaded-files" *ngIf="get2DFiles().length > 0">
          <div class="file-item" *ngFor="let file of get2DFiles(); let i = index; trackBy: trackByFileIndex">
            <span class="file-name">{{ file.fileName }}</span>
            <button class="remove-file-btn" (click)="remove2DFile(i)" title="Remove file">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                  fill="#212A37" />
                <path
                  d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                  fill="#212A37" />
                <path
                  d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                  fill="#212A37" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                  fill="#212A37" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="file-upload-actions">
        <button class="btn btn-primary submit-btn" [disabled]="!hasFilesForCurrentPartSubmission"
          (click)="submitPartFiles()">
          Submit Part File
        </button>
        <button class="btn btn-link continue-btn" *ngIf="isShowContinueWithoutFilesMessage()"
          (click)="continueWithoutFiles()">
          Continue without adding part files
        </button>
      </div>
    </div>
  </div>

  <!-- Configuration View - Part Configuration -->
  <div class="configuration-view" *ngIf="hasParts && isConfigurationView">
    <!-- Header -->
    <div class="file-upload-view">
      <div class="file-upload-header">
        <div class="part-info-fields">
          <div class="part-field editable-textbox input-group enter-rfq-name">
            <input type="text" [ngModel]="currentPart.partName"
              (ngModelChange)="onPartFieldChange(currentPartIndex, 'partName', $event)" placeholder="Enter part name"
              [ngClass]="{'error-border': getFieldError(currentPartIndex, 'partName')}"
              class="part-name-input form-control"
              [readonly]="config.readonly || integrationType === 'MFG' || integrationType === 'SUW'">
          </div>
          <div class="part-field editable-textbox input-group enter-rfq-name">
            <input type="text" [ngModel]="currentPart.partNumber"
              (ngModelChange)="onPartFieldChange(currentPartIndex, 'partNumber', $event)"
              placeholder="Enter part number"
              [ngClass]="{'error-border': getFieldError(currentPartIndex, 'partNumber')}"
              class="part-number-input form-control"
              [readonly]="config.readonly || integrationType === 'MFG' || integrationType === 'SUW'">
          </div>
        </div>
      </div>
    </div>
    <!-- Cost Builder Section -->
    <div class="cost-builder-section">
      <div class="section-header">
        <div class="cost-builder-heading">
          <div class="header-section-title">
            <h3 class="section-title">Cost Builder</h3>
            <button
              type="button"
              class="watch-demo-button"
              (click)="onWatchDemoClick()"
              [disabled]="config?.readonly"
              aria-label="Watch Cost Builder demo">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <g clip-path="url(#clip0_6220_10924)">
                    <path d="M7.91667 10H2.08333C1.531 9.99934 1.00148 9.77963 0.610925 9.38908C0.220367 8.99852 0.000661607 8.469 0 7.91667L0 2.08333C0.000661607 1.531 0.220367 1.00148 0.610925 0.610925C1.00148 0.220367 1.531 0.000661607 2.08333 0L7.91667 0C8.469 0.000661607 8.99852 0.220367 9.38908 0.610925C9.77963 1.00148 9.99934 1.531 10 2.08333V7.91667C9.99934 8.469 9.77963 8.99852 9.38908 9.38908C8.99852 9.77963 8.469 9.99934 7.91667 10ZM2.08333 0.833333C1.75181 0.833333 1.43387 0.965029 1.19945 1.19945C0.965029 1.43387 0.833333 1.75181 0.833333 2.08333V7.91667C0.833333 8.24819 0.965029 8.56613 1.19945 8.80055C1.43387 9.03497 1.75181 9.16667 2.08333 9.16667H7.91667C8.24819 9.16667 8.56613 9.03497 8.80055 8.80055C9.03497 8.56613 9.16667 8.24819 9.16667 7.91667V2.08333C9.16667 1.75181 9.03497 1.43387 8.80055 1.19945C8.56613 0.965029 8.24819 0.833333 7.91667 0.833333H2.08333ZM3.8925 7.08542C3.7188 7.08484 3.54834 7.03841 3.39833 6.95083C3.25014 6.86602 3.12715 6.74335 3.04193 6.59539C2.95671 6.44744 2.91233 6.27949 2.91333 6.10875V3.89125C2.91319 3.72048 2.95796 3.55267 3.04316 3.40467C3.12835 3.25666 3.25097 3.13366 3.39872 3.04802C3.54646 2.96237 3.71413 2.91708 3.8849 2.9167C4.05567 2.91631 4.22354 2.96085 4.37167 3.04583L6.57083 4.14375C6.72359 4.22621 6.85152 4.34803 6.94135 4.49658C7.03118 4.64512 7.07965 4.81499 7.08173 4.98858C7.08382 5.16216 7.03944 5.33314 6.95319 5.4838C6.86695 5.63446 6.74199 5.75931 6.59125 5.84542L4.35125 6.965C4.21154 7.04469 4.05333 7.08622 3.8925 7.08542ZM3.88208 3.75208C3.85912 3.75207 3.83656 3.75811 3.81667 3.76958C3.79506 3.7816 3.77712 3.79928 3.76479 3.82071C3.75246 3.84214 3.7462 3.86653 3.74667 3.89125V6.10875C3.74681 6.13311 3.75328 6.15701 3.76545 6.1781C3.77762 6.1992 3.79507 6.21677 3.81609 6.22908C3.8371 6.2414 3.86096 6.24803 3.88531 6.24834C3.90967 6.24865 3.93368 6.24261 3.955 6.23083L6.195 5.11083C6.21168 5.09779 6.22495 5.08088 6.23366 5.06158C6.24237 5.04227 6.24626 5.02114 6.245 5C6.24552 4.97522 6.23923 4.95077 6.22682 4.92931C6.2144 4.90786 6.19633 4.89023 6.17458 4.87833L3.97708 3.78042C3.94843 3.76284 3.91568 3.75307 3.88208 3.75208Z" fill="#2E58D6"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_6220_10924">
                      <rect width="10" height="10" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>Watch Demo</span>
            </button>
          </div>
          <p>
            Estimate the cost to fabricate this part. Your inputs will roll into the Unit Cost below but won’t appear on
            the buyer’s quote.
          </p>
        </div>
      </div>
    </div>
    <div class="main-section-area">
      <!-- Materials Section -->
      <div class="configuration-section">
        <div class="section-header">
          <h3 class="section-title" (click)="toggleSection('materials')">
            <span class="chevron-icon" [ngClass]="{'toggle-section-header': !showMaterials}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#212A37" stroke-width="1.3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Materials
          </h3>
          <!-- Add New Material Button -->
          <div class="add-item-form">
            <button class="add-button" (click)="startNewMaterial()">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 0.25C4.4341 0.25 4.58333 0.399238 4.58333 0.583333V3.91667H7.91667C8.10076 3.91667 8.25 4.06591 8.25 4.25C8.25 4.4341 8.10076 4.58333 7.91667 4.58333H4.58333V7.91667C4.58333 8.10076 4.43409 8.25 4.25 8.25C4.0659 8.25 3.91667 8.10076 3.91667 7.91667V4.58333H0.583333C0.399238 4.58333 0.25 4.4341 0.25 4.25C0.25 4.06591 0.399238 3.91667 0.583333 3.91667H3.91667V0.583333C3.91667 0.399238 4.06591 0.25 4.25 0.25Z" fill="#2E58D6" stroke="#2E58D6" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              Add Material
            </button>
          </div>
        </div>

        <div class="section-content" *ngIf="showMaterials">
          <!-- Header row for materials (shown only if there are materials) -->
          <div style="display: none;" class="material-item" *ngIf="currentPart.configuration.materials.length > 0">
            <div class="material-row">
              <div class="form-group label-fix-width">
                <label>Material</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Cost</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Reference </label>
                <div class="tooltip-container">
                  <svg class="tooltip-icon" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                    xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path
                      d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4.46535 3.29395L3.96438 5.64648C3.92922 5.81641 3.97902 5.91309 4.11672 5.91309C4.2134 5.91309 4.35988 5.87793 4.45949 5.79004L4.41555 5.99805C4.27199 6.1709 3.95559 6.29688 3.68313 6.29688C3.33156 6.29688 3.18215 6.08594 3.27883 5.6377L3.64797 3.90332C3.6802 3.75684 3.6509 3.7041 3.50441 3.66895L3.27883 3.62793L3.31984 3.4375L4.46535 3.29395ZM4 2.75C3.72386 2.75 3.5 2.52614 3.5 2.25C3.5 1.97386 3.72386 1.75 4 1.75C4.27614 1.75 4.5 1.97386 4.5 2.25C4.5 2.52614 4.27614 2.75 4 2.75Z"
                      fill="#212A37" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Loop through materials and show appropriate view based on per-material flag -->
          <ng-container *ngFor="let material of currentPart.configuration.materials; let i = index; trackBy: trackByMaterialIndex">
            
            <!-- Standard Material View (when quantity breakdown is disabled for this material) -->
            <div class="material-item" *ngIf="!isMaterialQuantityBreakdownEnabled(i)">
              <div class="material-row">
                <div class="form-group label-fix-width">
                  <label>Material</label>
                </div>
                <div class="form-group label-fix-width">
                  <label>Cost</label>
                </div>
                <div class="form-group label-fix-width">
                  <label>Reference </label>
                  <div class="tooltip-container">
                    <svg class="tooltip-icon" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                      xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path
                        d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4.46535 3.29395L3.96438 5.64648C3.92922 5.81641 3.97902 5.91309 4.11672 5.91309C4.2134 5.91309 4.35988 5.87793 4.45949 5.79004L4.41555 5.99805C4.27199 6.1709 3.95559 6.29688 3.68313 6.29688C3.33156 6.29688 3.18215 6.08594 3.27883 5.6377L3.64797 3.90332C3.6802 3.75684 3.6509 3.7041 3.50441 3.66895L3.27883 3.62793L3.31984 3.4375L4.46535 3.29395ZM4 2.75C3.72386 2.75 3.5 2.52614 3.5 2.25C3.5 1.97386 3.72386 1.75 4 1.75C4.27614 1.75 4.5 1.97386 4.5 2.25C4.5 2.52614 4.27614 2.75 4 2.75Z"
                        fill="#212A37" />
                    </svg>
                  </div>
                </div>
              </div>

              <div class="material-row">
                <div class="form-group">
                  <input type="text" [(ngModel)]="material.name" (change)="updateMaterial(i, 'name', material.name)"
                    placeholder="" class="material-input"
                    [ngClass]="{'errorClass': hasSectionFieldError('materials', i, 'name')}">
                </div>
                <div class="form-group">
                  <div class="cost-input">
                    <input type="text" [(ngModel)]="material.cost" (change)="updateMaterial(i, 'cost', material.cost)"
                      class="cost-input-field" appNumericInputV2 [showCurrency]="true" [showDashes]="false"
                      [ngClass]="{'errorClass': hasSectionFieldError('materials', i, 'cost')}">
                    <select [(ngModel)]="material.costType" (change)="updateMaterial(i, 'costType', material.costType)"
                      class="cost-select">
                      <option value="Per Unit">Per Unit</option>
                      <option value="Fixed">Fixed</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="reference-input">
                    <input type="text" [(ngModel)]="material.reference"
                      (change)="updateMaterial(i, 'reference', material.reference)" placeholder=""
                      class="reference-input-field">
                  </div>
                </div>
                <div class="delete-group">
                  <button class="remove-button" (click)="removeMaterial(i)" title="Remove material">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                          fill="#212A37" />
                        <path
                          d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                          fill="#212A37" />
                        <path
                          d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                          fill="#212A37" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                          fill="#212A37" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>

              <!-- Add Quantity Breakdown Button - For this specific material -->
              <div class="add-item-form-qty-breakdown" *ngIf="getValidQuantities().length > 1">
                <button class="add-qty-breakdown-btn" (click)="enableMaterialQuantityBreakdown(i)">
                  + Add Quantity Breakdown
                </button>
              </div>
            </div>

            <!-- Quantity Breakdown View (when quantity breakdown is enabled for this material) -->
            <div class="qty-breakdown-container" *ngIf="isMaterialQuantityBreakdownEnabled(i)">
              <div class="material-row">
                <div class="form-group label-fix-width">
                  <label>Material</label>
                </div>
                <div class="form-group label-fix-width">
                  <label>Cost</label>
                </div>
                <div class="form-group label-fix-width">
                  <label>Reference </label>
                  <div class="tooltip-container">
                    <svg class="tooltip-icon" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                      xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path
                        d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4.46535 3.29395L3.96438 5.64648C3.92922 5.81641 3.97902 5.91309 4.11672 5.91309C4.2134 5.91309 4.35988 5.87793 4.45949 5.79004L4.41555 5.99805C4.27199 6.1709 3.95559 6.29688 3.68313 6.29688C3.33156 6.29688 3.18215 6.08594 3.27883 5.6377L3.64797 3.90332C3.6802 3.75684 3.6509 3.7041 3.50441 3.66895L3.27883 3.62793L3.31984 3.4375L4.46535 3.29395ZM4 2.75C3.72386 2.75 3.5 2.52614 3.5 2.25C3.5 1.97386 3.72386 1.75 4 1.75C4.27614 1.75 4.5 1.97386 4.5 2.25C4.5 2.52614 4.27614 2.75 4 2.75Z"
                        fill="#212A37" />
                    </svg>
                  </div>
                </div>
              </div>
              
              <div class="material-row">
                <div class="form-group">
                  <input type="text" [(ngModel)]="material.name" (change)="updateMaterial(i, 'name', material.name)"
                    placeholder="" class="material-input"
                    [ngClass]="{'errorClass': hasSectionFieldError('materials', i, 'name')}">
                </div>
                <div class="form-group">
                  <input type="text" placeholder="Multiple Quantities" class="material-input quantity-input-label" readonly>
                </div>
                <div class="form-group">
                  <div class="reference-input">
                    <input type="text" [(ngModel)]="material.reference"
                      (change)="updateMaterial(i, 'reference', material.reference)" placeholder=""
                      class="reference-input-field">
                  </div>
                </div>
                <div class="delete-group">
                  <button class="remove-button" (click)="removeMaterial(i)" title="Remove material">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                          fill="#212A37" />
                        <path
                          d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                          fill="#212A37" />
                        <path
                          d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                          fill="#212A37" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                          fill="#212A37" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              
              <!-- Quantity-specific pricing rows (one row per quantity) -->
              <div class="material-row qty-row" *ngFor="let qty of getValidQuantities()">
                <div class="form-group fix-width">
                  <label class="label-units">
                    <span class="label-units-value">{{ qty }} Units</span>
                    <span class="label-units-line"></span>
                  </label>
                </div>
                <div class="form-group fix-width">
                  <div class="cost-input">
                    <input type="text" 
                      [ngModel]="getMaterialQuantityCost(i, qty)"
                      (ngModelChange)="setMaterialQuantityCost(i, qty, $event)"
                      class="cost-input-field" 
                      appNumericInputV2 
                      [showCurrency]="true" 
                      [showDashes]="false"
                      [ngClass]="{'errorClass': hasSectionFieldError('materials', i, 'cost')}">
                    <select 
                      [ngModel]="getMaterialQuantityCostType(i, qty)"
                      (ngModelChange)="setMaterialQuantityCostType(i, qty, $event)"
                      class="cost-select">
                      <option value="Fixed">Fixed</option>
                      <option value="Per Unit">Per Unit</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Remove Quantity Breakdown Button - For this specific material -->
              <div class="add-item-form-qty-breakdown">
                <button class="add-qty-breakdown-btn" (click)="disableMaterialQuantityBreakdown(i)">
                  - Remove Quantity Breakdown
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Tooling Section -->
      <div class="configuration-section">
        <div class="section-header">
          <h3 class="section-title" (click)="toggleSection('tooling')">
            <span class="chevron-icon" [ngClass]="{'toggle-section-header': !showTooling}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#212A37" stroke-width="1.3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Tooling
          </h3>
          <!-- Add New Tool Button -->
          <div class="add-item-form">
            <button class="add-button" (click)="startNewTool()"> 
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 0.25C4.4341 0.25 4.58333 0.399238 4.58333 0.583333V3.91667H7.91667C8.10076 3.91667 8.25 4.06591 8.25 4.25C8.25 4.4341 8.10076 4.58333 7.91667 4.58333H4.58333V7.91667C4.58333 8.10076 4.43409 8.25 4.25 8.25C4.0659 8.25 3.91667 8.10076 3.91667 7.91667V4.58333H0.583333C0.399238 4.58333 0.25 4.4341 0.25 4.25C0.25 4.06591 0.399238 3.91667 0.583333 3.91667H3.91667V0.583333C3.91667 0.399238 4.06591 0.25 4.25 0.25Z" fill="#2E58D6" stroke="#2E58D6" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              Add Tool
            </button>
          </div>
        </div>

        <div class="section-content" *ngIf="showTooling">
          <!-- Existing Tools -->
          <div class="tool-item" *ngIf="currentPart.configuration.tools.length > 0">
            <div class="tool-row">
              <div class="form-group label-fix-width">
                <label>Tool</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Cost</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Reference </label>
                <div class="tooltip-container">
                  <svg class="tooltip-icon" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                    xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path
                      d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4.46535 3.29395L3.96438 5.64648C3.92922 5.81641 3.97902 5.91309 4.11672 5.91309C4.2134 5.91309 4.35988 5.87793 4.45949 5.79004L4.41555 5.99805C4.27199 6.1709 3.95559 6.29688 3.68313 6.29688C3.33156 6.29688 3.18215 6.08594 3.27883 5.6377L3.64797 3.90332C3.6802 3.75684 3.6509 3.7041 3.50441 3.66895L3.27883 3.62793L3.31984 3.4375L4.46535 3.29395ZM4 2.75C3.72386 2.75 3.5 2.52614 3.5 2.25C3.5 1.97386 3.72386 1.75 4 1.75C4.27614 1.75 4.5 1.97386 4.5 2.25C4.5 2.52614 4.27614 2.75 4 2.75Z"
                      fill="#212A37" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="tool-item" *ngFor="let tool of currentPart.configuration.tools; let i = index">
            <div class="tool-row">
              <div class="form-group">
                <input type="text" [(ngModel)]="tool.name" (change)="updateTool(i, 'name', tool.name)" placeholder=""
                  class="tool-input" [ngClass]="{'errorClass': hasSectionFieldError('tools', i, 'name')}">
              </div>
              <div class="form-group">
                <div class="cost-input">
                  <input type="text" [(ngModel)]="tool.cost" (change)="updateTool(i, 'cost', tool.cost)"
                    class="cost-input-field" appNumericInputV2 [showCurrency]="true" [showDashes]="false"
                    [ngClass]="{'errorClass': hasSectionFieldError('tools', i, 'cost')}">
                  <select [(ngModel)]="tool.costType" (change)="updateTool(i, 'costType', tool.costType)"
                    class="cost-select">
                    <option *ngFor="let type of costTypes" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="reference-input">
                  <input type="text" [(ngModel)]="tool.reference" (change)="updateTool(i, 'reference', tool.reference)"
                    placeholder="" class="reference-input-field">
                </div>
              </div>
              <div class="delete-group">
                <button class="remove-button" (click)="removeTool(i)" title="Remove tool">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                        fill="#212A37" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                        fill="#212A37" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Processes Section -->
      <div class="configuration-section">
        <div class="section-header">
          <h3 class="section-title" (click)="toggleSection('processes')">
            <span class="chevron-icon" [ngClass]="{'toggle-section-header': !showProcesses}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#212A37" stroke-width="1.3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Processes
          </h3>
          <!-- Add New Process Button -->
          <div class="add-item-form">
            <button class="add-button" (click)="startNewProcess()"> 
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 0.25C4.4341 0.25 4.58333 0.399238 4.58333 0.583333V3.91667H7.91667C8.10076 3.91667 8.25 4.06591 8.25 4.25C8.25 4.4341 8.10076 4.58333 7.91667 4.58333H4.58333V7.91667C4.58333 8.10076 4.43409 8.25 4.25 8.25C4.0659 8.25 3.91667 8.10076 3.91667 7.91667V4.58333H0.583333C0.399238 4.58333 0.25 4.4341 0.25 4.25C0.25 4.06591 0.399238 3.91667 0.583333 3.91667H3.91667V0.583333C3.91667 0.399238 4.06591 0.25 4.25 0.25Z" fill="#2E58D6" stroke="#2E58D6" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              Add Process
            </button>
          </div>
        </div>

        <div class="section-content" *ngIf="showProcesses">
          <!-- Existing Processes -->
          <div class="process-item" *ngIf="currentPart.configuration.processes.length > 0">
            <div class="process-row">
              <div class="form-group label-fix-width">
                <label>Process</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Machine Cost</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Setup Cost</label>
              </div>
            </div>
          </div>
          <div class="process-item" *ngFor="let process of currentPart.configuration.processes; let i = index">
            <div class="process-row">
              <div class="form-group">
                <input type="text" [(ngModel)]="process.name" (change)="updateProcess(i, 'name', process.name)"
                  placeholder="" class="process-input"
                  [ngClass]="{'errorClass': hasSectionFieldError('processes', i, 'name')}">
              </div>
              <div class="form-group">
                <div class="cost-input">
                  <input type="text" [(ngModel)]="process.machineCost"
                    (change)="updateProcess(i, 'machineCost', process.machineCost)" class="cost-input-field"
                    appNumericInputV2 [showCurrency]="true" [showDashes]="false"
                    [ngClass]="{'errorClass': hasSectionFieldError('processes', i, 'cost')}">
                  <select [(ngModel)]="process.machineCostType"
                    (change)="updateProcess(i, 'machineCostType', process.machineCostType)" class="cost-select">
                    <option *ngFor="let type of costTypes" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="cost-input">
                  <input type="text" [(ngModel)]="process.setupCost"
                    (change)="updateProcess(i, 'setupCost', process.setupCost)" class="cost-input-field"
                    appNumericInputV2 [showCurrency]="true" [showDashes]="false"
                    [ngClass]="{'errorClass': hasSectionFieldError('processes', i, 'cost')}">
                  <select [(ngModel)]="process.setupCostType"
                    (change)="updateProcess(i, 'setupCostType', process.setupCostType)" class="cost-select">
                    <option *ngFor="let type of costTypes" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div>
              <div class="delete-group">
                <button class="remove-button" (click)="removeProcess(i)" title="Remove process">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                        fill="#212A37" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                        fill="#212A37" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Costs Section -->
      <div class="configuration-section">
        <div class="section-header">
          <h3 class="section-title" (click)="toggleSection('additionalCosts')">
            <span class="chevron-icon" [ngClass]="{'toggle-section-header': !showAdditionalCosts}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="#212A37" stroke-width="1.3" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            Additional Costs
          </h3>
        <!-- Add New Process Button -->
        <div class="add-item-form">
          <button class="add-button" (click)="startNewAdditionalCost()">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 0.25C4.4341 0.25 4.58333 0.399238 4.58333 0.583333V3.91667H7.91667C8.10076 3.91667 8.25 4.06591 8.25 4.25C8.25 4.4341 8.10076 4.58333 7.91667 4.58333H4.58333V7.91667C4.58333 8.10076 4.43409 8.25 4.25 8.25C4.0659 8.25 3.91667 8.10076 3.91667 7.91667V4.58333H0.583333C0.399238 4.58333 0.25 4.4341 0.25 4.25C0.25 4.06591 0.399238 3.91667 0.583333 3.91667H3.91667V0.583333C3.91667 0.399238 4.06591 0.25 4.25 0.25Z" fill="#2E58D6" stroke="#2E58D6" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
              Add Additional Cost
            </button>
        </div>
        </div>

        <div class="section-content" *ngIf="showAdditionalCosts">
          <div class="additional-cost-item" *ngIf="currentPart.configuration.additionalCosts.length > 0">
            <div class="form-row">
              <div class="form-group label-fix-width">
                <label>Name</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Cost</label>
              </div>
              <div class="form-group label-fix-width">
                <label>Reference </label>
                <div class="tooltip-container">
                  <svg class="tooltip-icon" (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                    xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path
                      d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM4.46535 3.29395L3.96438 5.64648C3.92922 5.81641 3.97902 5.91309 4.11672 5.91309C4.2134 5.91309 4.35988 5.87793 4.45949 5.79004L4.41555 5.99805C4.27199 6.1709 3.95559 6.29688 3.68313 6.29688C3.33156 6.29688 3.18215 6.08594 3.27883 5.6377L3.64797 3.90332C3.6802 3.75684 3.6509 3.7041 3.50441 3.66895L3.27883 3.62793L3.31984 3.4375L4.46535 3.29395ZM4 2.75C3.72386 2.75 3.5 2.52614 3.5 2.25C3.5 1.97386 3.72386 1.75 4 1.75C4.27614 1.75 4.5 1.97386 4.5 2.25C4.5 2.52614 4.27614 2.75 4 2.75Z"
                      fill="#212A37" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="additional-cost-item"
            *ngFor="let cost of currentPart.configuration.additionalCosts; let i = index">
            <div class="form-row">
              <div class="form-group">
                <input type="text" [(ngModel)]="cost.name" (change)="updateAdditionalCost(i, 'name', cost.name)"
                  placeholder="" class="process-input"
                  [ngClass]="{'errorClass': hasSectionFieldError('additionalCosts', i, 'name')}">
              </div>
              <div class="form-group">
                <div class="cost-input">
                  <input type="text" [(ngModel)]="cost.cost" (change)="updateAdditionalCost(i, 'cost', cost.cost)"
                    class="cost-input-field" appNumericInputV2 [showCurrency]="true" [showDashes]="false"
                    [ngClass]="{'errorClass': hasSectionFieldError('additionalCosts', i, 'cost')}">
                  <select [(ngModel)]="cost.costType" (change)="updateAdditionalCost(i, 'costType', cost.costType)"
                    class="cost-select">
                    <option *ngFor="let type of costTypes" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group">
              <label>Cost</label>
              <div class="cost-input">
                <input type="text" [(ngModel)]="cost.cost" (change)="updateAdditionalCost(i, 'cost', cost.cost)"
                  placeholder="0.00">
                <select [(ngModel)]="cost.costType" (change)="updateAdditionalCost(i, 'costType', cost.costType)">
                  <option *ngFor="let type of costTypes" [value]="type">{{ type }}</option>
                </select>
              </div>
            </div> -->
              <div class="form-group">
                <input type="text" [(ngModel)]="cost.reference"
                  (change)="updateAdditionalCost(i, 'reference', cost.reference)" placeholder=""
                  class="reference-input-field">
              </div>
              <div class="delete-group">
                <button class="remove-button" (click)="removeAdditionalCost(i)">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M4.125 4.125C4.33211 4.125 4.5 4.29289 4.5 4.5V9C4.5 9.20711 4.33211 9.375 4.125 9.375C3.91789 9.375 3.75 9.20711 3.75 9V4.5C3.75 4.29289 3.91789 4.125 4.125 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M6 4.125C6.20711 4.125 6.375 4.29289 6.375 4.5V9C6.375 9.20711 6.20711 9.375 6 9.375C5.79289 9.375 5.625 9.20711 5.625 9V4.5C5.625 4.29289 5.79289 4.125 6 4.125Z"
                        fill="#212A37" />
                      <path
                        d="M8.25 4.5C8.25 4.29289 8.08211 4.125 7.875 4.125C7.66789 4.125 7.5 4.29289 7.5 4.5V9C7.5 9.20711 7.66789 9.375 7.875 9.375C8.08211 9.375 8.25 9.20711 8.25 9V4.5Z"
                        fill="#212A37" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.875 2.25C10.875 2.66421 10.5392 3 10.125 3H9.75V9.75C9.75 10.5784 9.07843 11.25 8.25 11.25H3.75C2.92157 11.25 2.25 10.5784 2.25 9.75V3H1.875C1.46079 3 1.125 2.66421 1.125 2.25V1.5C1.125 1.08579 1.46079 0.75 1.875 0.75H4.5C4.5 0.335786 4.83579 0 5.25 0H6.75C7.16421 0 7.5 0.335786 7.5 0.75H10.125C10.5392 0.75 10.875 1.08579 10.875 1.5V2.25ZM3.08853 3L3 3.04426V9.75C3 10.1642 3.33579 10.5 3.75 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75V3.04426L8.91147 3H3.08853ZM1.875 2.25V1.5H10.125V2.25H1.875Z"
                        fill="#212A37" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pricing Table -->
    <div class="pricing-section">
      <div class="pricing-table">
        <table>
          <thead>
            <tr>
              <th class="quantity-header">Quantity</th>
              <th class="leadtime-header">Leadtime</th>
              <th class="unit-cost-header">Unit Cost</th>
              <th class="markup-header">Markup %</th>
              <th class="unit-price-header">Unit Price</th>
              <th class="total-header" colspan="2">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of currentPart.quantityPricing; let i = index; trackBy: trackByPricingIndex">
              <td>
                <!-- Show input field if quantity is editable or has a value -->
                <input *ngIf="isQuantityRowEditable(row) || row.quantity !== null" type="text"
                  [(ngModel)]="row.quantity" (change)="updatePricingRow(i, 'quantity', row.quantity)"
                  class="pricing-input quantity-input" placeholder="0" appNumericInputV2
                  [disabled]="integrationType === 'MFG' || integrationType === 'SUW'"
                  [ngClass]="{'errorClass': hasQuantityError(currentPartIndex)}" [attr.data-quantity-index]="i">
                <!-- Show clickable "--" for non-MFG integrations when quantity is null -->
                <!-- <span *ngIf="isQuantityRowEditable(row)" 
                      class="dash-display" 
                      (click)="startEditingQuantity(row, i)"
                      title="Click to add quantity">---</span> -->
                <!-- Show static "--" for MFG integration when quantity is null -->
                <span *ngIf="row.quantity === null && integrationType === 'MFG' && !isQuantityRowEditable(row)"
                  class="dash-display">--</span>
              </td>
              <td>
                <span *ngIf="!row.showLeadTimeInputFields"
                  [class]="row.leadtimeValue && row.leadtimeValue !== 0 ? 'pricing-input filled-leadtime' : 'dash-display'"
                  [ngClass]="{'errorClass': hasLeadTimeError(i)}"
                  [class.leadtime-error]="(!row.leadtimeValue || row.leadtimeValue === 0) && getFieldError(currentPartIndex, 'leadtime') && hasQuantityGreaterThanZero()"
                  (click)="isQuantityEditable(row) ? startEditingLeadtime(row, i) : null"
                  [title]="(!row.leadtimeValue || row.leadtimeValue === 0) ? 'Click to add leadtime' : ''">
                  {{(row.leadtimeValue && row.leadtimeValue !== 0) ? (row.leadtimeValue + ' ' + row.leadtimeUnit) :
                  '--'}}
                </span>

                <div class="form-group leadtime-input-group">
                  <div class="cost-input" *ngIf="row.showLeadTimeInputFields">
                    <input type="text" [(ngModel)]="row.leadtimeValue" [disabled]="!isQuantityEditable(row)"
                      (change)="updatePricingRow(i, 'leadtimeValue', row.leadtimeValue)" placeholder="0"
                      class="cost-input-field" appNumericInputV2 [showCurrency]="false" [showDashes]="true"
                      [allowDecimals]="false" [ngClass]="{'errorClass': hasLeadTimeError(i)}"
                      [attr.data-leadtime-index]="i">
                    <select [(ngModel)]="row.leadtimeUnit"
                      (change)="updatePricingRow(i, 'leadtimeUnit', row.leadtimeUnit)" class="cost-select">
                      <option *ngFor="let unit of leadtimeUnits" [value]="unit">{{ unit }}</option>
                    </select>
                  </div>


                </div>
                <!-- LeadTime validation error message - removed, now showing red -- instead -->
              </td>
              <td>
                <input type="text" [(ngModel)]="row.unitCost" (change)="updatePricingRow(i, 'unitCost', row.unitCost)"
                  disabled class="pricing-input cost-input" placeholder="0" appNumericInputV2 [showCurrency]="true"
                  [showDashes]="true">
              </td>
              <td>
                <input type="text" [(ngModel)]="row.markup" (change)="updatePricingRow(i, 'markup', row.markup)"
                  [disabled]="!isQuantityEditable(row)" class="pricing-input markup-input" placeholder="0"
                  appNumericInputV2 [showPercentage]="true" [showCurrency]="false" [showDashes]="true">
              </td>
              <td>
                <input type="text" [(ngModel)]="row.unitPrice" [disabled]="!isQuantityEditable(row)"
                  (change)="updatePricingRow(i, 'unitPrice', row.unitPrice)" class="pricing-input price-input"
                  placeholder="0" appNumericInputV2 [showCurrency]="true" [showDashes]="true"
                  [ngClass]="{'errorClass': hasUnitPriceError(currentPartIndex, i)}">
              </td>
              <td>
                <!-- <span class="total-display">{{ row.total | formatNumber:true }}</span> -->
                <input type="text" [(ngModel)]="row.total" [disabled]="!isQuantityEditable(row)"
                  (change)="updatePricingRow(i, 'total', row.total)" class="pricing-input price-input" placeholder="0"
                  appNumericInputV2 [showCurrency]="true" [showDashes]="true"
                  [ngClass]="{'errorClass': hasTotalError(currentPartIndex, i)}">
              </td>
            </tr>
          </tbody>
        </table>
        <div class="add-item-form">
          <span class="edit-icon">
            <a>
              <img src="assets/img/svg/pencil-white.svg" alt="add-item">
            </a>
          </span>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-primary" (click)="confirmPartPricing()">Confirm Part Pricing</button>
    </div>
  </div>

<!-- Feedback Survey Modal -->
<div class="modal-overlay" *ngIf="showFeedbackSurvey">
  <div class="feedback-modal">
    <!-- Modal Header -->
    <div class="feedback-header">
      <button class="feedback-back-btn" *ngIf="feedbackStep === 'comment'" (click)="onFeedbackBack()">
        <span>‹</span>
      </button>
      <div class="feedback-progress">
        <span>{{ feedbackStep === 'rating' ? '1' : '2' }}/2</span>
      </div>
      <button class="feedback-close-btn" (click)="onFeedbackClose()">
        <span>×</span>
      </button>
    </div>

    <!-- Step 1: Rating -->
    <div class="feedback-content" *ngIf="feedbackStep === 'rating'">
      <h3 class="feedback-title">How was your experience with Quote Assist Tool?</h3>
      <div class="feedback-rating-buttons">
        <button 
          class="feedback-rating-btn positive" 
          (click)="onFeedbackRatingSelect('positive')"
          type="button">
          <span class="thumbs-icon">
            <img src="assets/img/svg/like-svg.svg" alt="Thumbs Up">
          </span>
        </button>
        <button 
          class="feedback-rating-btn negative" 
          (click)="onFeedbackRatingSelect('negative')"
          type="button">
          <span class="thumbs-icon">
            <img src="assets/img/svg/dislike-svg.svg" alt="Thumbs Up">
          </span>
        </button>
      </div>
    </div>

    <!-- Step 2: Comment -->
    <div class="feedback-content" *ngIf="feedbackStep === 'comment'">
      <h3 class="feedback-title">What did you like or dislike about this experience?</h3>
      <div class="feedback-form">
        <textarea 
          class="feedback-textarea"
          [(ngModel)]="feedbackComment"
          placeholder=""
          rows="1"
          maxlength="500">
        </textarea>
        <button 
          class="feedback-submit-btn"
          (click)="onFeedbackSubmit()"
          type="button"
          [disabled]="isSubmittingFeedback">
          <span *ngIf="!isSubmittingFeedback">Submit</span>
          <span *ngIf="isSubmittingFeedback">Submitting...</span>
        </button>
      </div>
    </div>
  </div>
</div>

  <!-- Feedback Survey Modal -->
  <div class="modal-overlay" *ngIf="showFeedbackSurvey">
    <div class="feedback-modal">
      <!-- Modal Header -->
      <div class="feedback-header">
        <button class="feedback-back-btn" *ngIf="feedbackStep === 'comment'" (click)="onFeedbackBack()">
          <span>‹</span>
        </button>
        <div class="feedback-progress">
          <span>{{ feedbackStep === 'rating' ? '1' : '2' }}/2</span>
        </div>
        <button class="feedback-close-btn" (click)="onFeedbackClose()">
          <span>×</span>
        </button>
      </div>

      <!-- Step 1: Rating -->
      <div class="feedback-content" *ngIf="feedbackStep === 'rating'">
        <h3 class="feedback-title">Is this quoting experience helpful for you?</h3>
        <div class="feedback-rating-buttons">
          <button class="feedback-rating-btn positive" (click)="onFeedbackRatingSelect('positive')" type="button">
            <span class="thumbs-icon">👍</span>
          </button>
          <button class="feedback-rating-btn negative" (click)="onFeedbackRatingSelect('negative')" type="button">
            <span class="thumbs-icon">👎</span>
          </button>
        </div>
      </div>

      <!-- Step 2: Comment -->
      <div class="feedback-content" *ngIf="feedbackStep === 'comment'">
        <h3 class="feedback-title">What makes you feel that way?</h3>
        <div class="feedback-form">
          <textarea class="feedback-textarea" [(ngModel)]="feedbackComment" placeholder="I think..." rows="4"
            maxlength="500">
        </textarea>
          <button class="feedback-submit-btn" (click)="onFeedbackSubmit()" type="button">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>